@import "../../../../../shared/styles/base";

.EmptyStateBanner {
  display: flex;
  justify-content: center;
  align-items: center;

  min-height: 180px;
  width: 100%;
  border-radius: 8px;
  padding: 0 2rem;
  padding-left: 4rem;
  background-color: #fff;

  &.HasBackground {
    background-color: $ds-violet-50;
  }

  &.HasGraphic {
    justify-content: space-between;
  }

  &.HasTitle {
    padding: 48px 3.9rem;
  }

  &.IsVertical {
    flex-direction: column;
    height: auto;
    padding: 48px 60px;

    .Title {
      margin-bottom: 30px;
      max-width: 560px;
    }

    .Information {
      max-width: 100%;
      max-width: 560px;
      margin-right: 0;
    }

    .Illustration {
      order: -1;
      margin-bottom: 2rem;
    }
  }

  &.compact {
    padding: 1.5rem;

    img {
      height: 75px;
      margin-bottom: 16px !important;
    }

    .CtaButton {
      margin-top: 16px;
    }
  }

  &.compactDialog {
    padding: 0;
  }

  .Title {
    display: block;
    font-size: $ds-font-size-h3;
    font-weight: 500;
    margin: 0;
    margin-bottom: 20px;
  }

  .Information {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    max-width: 315px;

    font-size: $ds-font-size-b1;
    line-height: 24px;
    text-wrap: wrap;
    color: $ds-neutral-900;
    margin-right: 1rem;
  }

  .CtaButton {
    margin-top: 24px;
  }

  @media screen and (max-width: $tablet) {
    flex-direction: column-reverse;
    height: auto;
    padding: 2rem;
  }
}
